module.exports = __webpack_public_path__ + "img/accept.795cc5dc.png";